/* eslint-disable max-lines */
PHI.checkout = {
  otaformData: '',
  bind: function() {
    this.displayErrors();
  },
  displayErrors: function() {
    var errorPopup = $('.shopping-cart').find('.error-popup'),
        errorNumber = errorPopup.find('span.number_of_errors'),
        warningNumber = errorPopup.find('span.number_of_warnings'),
        errorMessages = $('.shopping-cart').find('.error-message.error'),
        warningMessages = $('.shopping-cart').find('.error-message.warning'),

        errorsText = errorPopup.find('span.errors_text'),
        warningsText = errorPopup.find('span.warnings_text'),
        andText = errorPopup.find('span.and_text'),

        $errorRows = $('.shopping-row.error'),
        opened = false;

    if ($errorRows.length > 0) {
    /* eslint-disable no-use-before-define *//* eslint-disable vars-on-top */
      var needPopup = displayPopup(errorPopup, errorMessages, warningMessages, errorNumber, warningNumber, errorsText, andText, warningsText);

      /* eslint-enable no-use-before-define *//* eslint-enable vars-on-top */
      if (needPopup === true) {
        errorPopup.slideDown('fast');
      }
    } else {
      errorPopup.slideUp('fast');
    }

    if (!opened) {
      $errorRows.each(function() {
        /* eslint-disable id-match */
        var errorM = $(this).find('.error-message');

        /* eslint-enable id-match */
        errorM.find('i.closeRound').click(function() {
          var shoppingParent = $(this).parents('.shopping-row');

          $(this).parents('.error-message').slideUp('fast', function() {
            if (shoppingParent.height() < 50) {
              shoppingParent.removeClass('error');
            }

            $(this).remove();
            errorMessages = $('.error-message.error');
            warningMessages = $('.error-message.warning');
            /* eslint-disable no-use-before-define */
            displayPopup(errorPopup, errorMessages, warningMessages, errorNumber, warningNumber, errorsText, andText, warningsText);
            /* eslint-enable no-use-before-define */
          });
        });
      });
    }
  },
  onetimeAddressValidation: function($fieldElement, showError) {
    var validationSuccess = true,
        $errorContainer = $fieldElement.parents('.ph-signup__error'),
        $inputContainer = $errorContainer.parent(),
        $errorMessageBox = $errorContainer.find('.ph-register__emptyvalue'),
        fieldValue = $fieldElement.val(),
        fieldEmptyMsg = $inputContainer.attr('data-emptycontent'),
        fieldRegexVal = $inputContainer.attr('data-regexcontent'),
        fieldErrorMsg = $inputContainer.attr('data-regexError'),
        fieldMandatory = $fieldElement.attr('data-mandatory'),
        messageText = '';

    if (fieldMandatory === 'true' && !fieldValue) {
      messageText = fieldEmptyMsg;
      validationSuccess = false;
    } else if (fieldValue && fieldRegexVal && !new RegExp(fieldRegexVal).test(fieldValue)) {
      messageText = fieldErrorMsg;
      validationSuccess = false;
    } else if ($fieldElement.attr('addressvalidation') === '') {
      $errorContainer.removeClass(ACC.newregisterpage.errorClass);
      $errorMessageBox.text('');
    }

    if (validationSuccess === false && showError === true) {
      $errorContainer.addClass(ACC.newregisterpage.errorClass);
      $errorMessageBox.text(messageText);
    }

    return validationSuccess;
  },
  onetimeAllFieldValidation: function(showError) {
    var validationOk = true;

    $('.otafields input:visible,.otafields select:visible').each(function() {
      if (!PHI.checkout.onetimeAddressValidation($(this), showError)) {
        validationOk = false;
        $('#Place-order-button').addClass('ph-disable-button');
      }
    });

    return validationOk;
  },
  showGlobalErrorMessage: function(errorMsg) {
    var errorMessage = errorMsg;

    if (!errorMessage) {
      errorMessage = $('#ph-addressGenericError').val();
    }

    $('.ph-register_errorContainer').removeClass('hidden').addClass('ph-redError').text(errorMessage);
  },
  otaValidationErrors: function(element, errorText) {
    var errorspanElem = $(element).parents('.ph-' + ACC.newregisterpage.signupError);

    errorspanElem.find('.' + ACC.newregisterpage.emptyVal).removeClass('ph-blueError').text(errorText);
    errorspanElem.addClass(ACC.newregisterpage.errorClass);
  },
  addressOtaFields: function() {
    var addressFields = '#ota_street,#ota_houseNumber,#ota_postalCode,#ota_city,#ota_region,#ota_country';

    $(addressFields).each(function() {
      $(this).addClass('otafield_address');
    });
  },
  addressOtaFieldError: function(failedValue, fldName) {
    if ($('#otAddressAllowedWhenError').val() !== 'true') {
      $('#otaValidationCheck').val(failedValue);
    }

    $(document).find('.otafields .ph-form_field_error .ph-commonfield').attr('addressvalidation', failedValue);

    if (fldName) {
      $(document).find('#ota_' + fldName).attr('addressvalidation', failedValue);
    }

    if (failedValue === '') {
      $(document).find('.otafields .ph-commonfield').attr('addressvalidation', failedValue);
    }
  },
  otaAddressValidation: function(addressValidationResponse) {
    var signupError = 'signup__error',
        emptyVal = 'ph-register__emptyvalue',
        cityRegionError = $('#ph-cityRegionError').val(),
        streetnameError = $('#ph-streetnameError').val(),
        houseNumberError = $('#ph-houseNumberError').val(),
        addressGenericError = $('#ph-addressGenericError').val(),
        addressSuccessMsg = $('#ph-addressSuccessMsg').val(),
        addressFields = 'otafield_address',
        errorClass = 'form_field_error ph-form_field_error';

    PHI.checkout.addressOtaFields();
    $('.otafields .ph-signup__error').removeClass(errorClass);
    $('.ph-register_errorContainer').addClass('hidden');
    $(document).find('.' + addressFields + ' .' + emptyVal).text('');

    if (addressValidationResponse.errorKey) {
      $(document).find('.' + addressFields + ' .' + emptyVal).removeClass('ph-blueError');

      if (addressValidationResponse.errorKey === 'genericError') {
        PHI.checkout.showGlobalErrorMessage(addressGenericError);
        $(document).find('.' + addressFields).parents('.ph-' + signupError).addClass(errorClass);
        $('#ota_country').parents('.ph-' + signupError).removeClass(errorClass);
      } else if (addressValidationResponse.errorKey === 'townCity') {
        PHI.checkout.otaValidationErrors('#ota_city', cityRegionError);
        PHI.checkout.otaValidationErrors('#ota_region', cityRegionError);
      } else if (addressValidationResponse.errorKey === 'streetName') {
        PHI.checkout.otaValidationErrors('#ota_street', streetnameError);
      } else if (addressValidationResponse.errorKey === 'houseNumber') {
        PHI.checkout.otaValidationErrors('#ota_houseNumber', houseNumberError);
      } else if (addressValidationResponse.errorKey === 'countryIso') {
        PHI.checkout.showGlobalErrorMessage(addressGenericError);
        $(document).find('.' + addressFields).parents('.ph-' + signupError).addClass(errorClass);
      }

      if ($('#addressValidationEnabled').val() === 'true') {
        PHI.checkout.addressOtaFieldError('failed');
      }
    } else if (addressValidationResponse.fieldDetails.length > 0) {
      addressValidationResponse.fieldDetails.forEach(function(fldInput) {
        $('#ota_' + fldInput.fieldName).val(fldInput.fieldValue);
        $('#ota_' + fldInput.fieldName).parents('.ph-' + signupError).find(' .' + emptyVal).addClass('ph-blueError')
          .text(addressSuccessMsg);
        PHI.checkout.addressOtaFieldError('updated', fldInput.fieldName);
      });
    }
  },
  shippingFieldEvents: function($this) {
    var formData = $('.otafields input,.otafields select').serialize();

    PHI.checkout.onetimeAddressValidation($this, true);
    PHI.checkout.addressOtaFieldError('');

    if (PHI.checkout.onetimeAllFieldValidation(false) && PHI.checkout.otaformData !== formData) {
      $('.ph-popup_overlay').removeClass('hidden');
      PHI.checkout.otaformData = formData;
      $.ajax({
        url: ACC.config.encodedContextPath + '/checkout/single/summary/setOneTimeAddress',
        type: 'POST',
        data: formData,
        datatype: 'json',
        scrolling: true,
        success: function(responseData) {
          $('.ph-popup_overlay').addClass('hidden');

          if (responseData.addressValidationResponse && $('#addressValidationEnabled').val() === 'true') {
            PHI.checkout.otaAddressValidation(responseData.addressValidationResponse);
          }

          if (responseData.otaStatus === true && responseData.cartData) {
            PHI.common.updateCartDetails(responseData.cartData);
          }

          $('#purchaseOrderNumber').trigger('blur');
        }
      });
    }
  }
};

/* eslint-disable no-implicit-globals */
/* eslint-disable max-params */
/* eslint-disable max-statements */
function displayPopup(errorPopup, errorMessages, warningMessages, errorNumber, warningNumber, errorsText, andText, warningsText) {
  var needPopup = false;

  if (errorMessages.length > 0 && warningMessages.length > 0) {
    errorNumber.text(errorMessages.length);
    warningNumber.text(warningMessages.length);
    errorNumber.show();
    warningNumber.show();
    warningsText.show();
    errorsText.show();
    andText.show();
    needPopup = true;
  } else if (errorMessages.length > 0 && warningMessages.length === 0) {
    errorNumber.text(errorMessages.length);
    warningNumber.hide();
    warningsText.hide();
    andText.hide();
    needPopup = true;
  } else if (errorMessages.length === 0 && warningMessages.length > 0) {
    warningNumber.text(warningMessages.length);
    errorNumber.hide();
    errorsText.hide();
    andText.hide();
    warningNumber.show();
    warningsText.show();
    needPopup = true;
  } else {
    errorPopup.slideUp('fast');
  }

  return needPopup;
}

/* eslint-enable no-implicit-globals */
/* eslint-enable max-params */
/* eslint-enable max-statements */
$(function() {
  PHI.checkout.bind();
});

$(document).ready(function() {
  $('input:radio[name="singleDelivery"]').change(function() {
    if ($(this).is(':checked') && $(this).val() === 'true') {
      $('#ph-multiItem-section').addClass('hidden');
      $('#ph-singleItem-section').removeClass('hidden');

      $('body, html').animate({
        scrollTop: 500
      });
    } else {
      $('#ph-singleItem-section').addClass('hidden');
      $('#ph-multiItem-section').removeClass('hidden');
    }
  });


  $(document).on('click', '.ph-ga__checkout', function() {
    var eventType = 'ecommerce.checkout.cartview';

    ACC.googleanalytics.trackCartViewGoogleAnalytics(eventType);
  });

  $(document).on('click', '.ph-ga__placeorder', function() {
    var paymentStep = 'delivery',
        paymentOption = '';

    if ($('.ph-enabledSingleBlock').length > 0) {
      paymentOption = 'Single Delivery';
    } else {
      paymentOption = document.querySelector('input[name="singleDelivery"]:checked').parentElement.textContent.trim();
    }

    ACC.googleanalytics.gaEventForCheckoutStepOption(paymentStep, paymentOption);
  });

  if ($('.otafields').length > 0) {
    $(document).on('blur', '.otafields input.ph-commonfield:visible', function() {
      PHI.checkout.shippingFieldEvents($(this));
    });
    $(document).on('change', '.otafields select.ph-commonfield:visible', function() {
      PHI.checkout.shippingFieldEvents($(this));
    });

    if ($('#ota_country').val()) {
      ACC.newregisterpage.getCommonRegion($('#ota_country').val(), '#ota_region');
    }

    $(document).on('change', '.otafields #ota_country', function() {
      ACC.newregisterpage.getCommonRegion($(this).val(), '#ota_region');
    });
  }
});


$(window).on('load', function() {
  var placeorderforga = '.ph-ga__placeorder',
      eventTypeForConfirm = 'ecommerce.checkout.purchase',
      paymentConfirmStep = 'payment',
      paymentConfirmOption = '',
      paymentTypeConfirm = $('.ph-orderPaymentType').val(),
      eventTypeForCheckoutStep = '',
      urlLinkFail = window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/checkout/single/paymentOptions',
      triggerFail = 'linkCategory.failure',
      compnameFail = '.adyen-checkout__button--pay',
      descFail = 'Payment failed',
      userEventObjFail = '';

  if ($('.ph-vieworder-link').length > 0) {
    if (paymentTypeConfirm === 'CARD') {
      paymentConfirmOption = 'CARD';
    } else {
      paymentConfirmOption = 'ACCOUNT';
    }

    ACC.googleanalytics.trackCartViewGoogleAnalytics(eventTypeForConfirm);
    ACC.googleanalytics.gaEventForCheckoutStepOption(paymentConfirmStep, paymentConfirmOption);
  }

  if ($(placeorderforga).length > 0 || $('#ph-paynow').length > 0) {
    eventTypeForCheckoutStep = 'ecommerce.checkout.step';
    ACC.googleanalytics.trackCartViewGoogleAnalytics(eventTypeForCheckoutStep);
  }

  function createUserEventObj(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  }

  $(document).on('click', '.ph-paynowbtn', function() {
    var urlLink = window.location.protocol + '//' + window.location.host + ACC.config.encodedContextPath + '/checkout/single/add-payment-method',
        trigger = 'linkCategory.clickPaynow',
        compname = '.ph-paynowbtn',
        desc = 'Online payment',
        userEventObj = '';

    userEventObj = createUserEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  if ($('#ph-paynow').length > 0 && $('.ph-adyenPaymentError').length > 0) {
    userEventObjFail = createUserEventObj(urlLinkFail, descFail, triggerFail, compnameFail);
    ACC.googleanalytics.gaEventsForLinks(userEventObjFail);
  }
});
/* eslint-enable max-lines */
